import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-otp-code',

  templateUrl: './otp-code.component.html',
  styleUrls: ['./otp-code.component.css'],
})
export class OtpCodeComponent {
  otpArray: string[] = Array(6).fill('');
  otpValues: string[] = [];
  logo = './assets/' + environment.projectName + '/media/header/logo.png';
  lang: string = '';
  constructor(private route: ActivatedRoute) {
    this.route.params.subscribe((params) => {
      if (params) {
        this.lang = params['lang'];
      }
    });
  }
  onInput(event: Event, index: number): void {
    console.log(this.otpValues);
    const input = event.target as HTMLInputElement;
    if (input.value.length > 1) {
      input.value = input.value.slice(0, 1);
    }

    const nextInput = document.querySelectorAll('.otp-input')[
      index + 1
    ] as HTMLInputElement;
    if (input.value.length === 1 && index < this.otpArray.length - 1) {
      nextInput.focus();
    } else if (index === this.otpArray.length - 1) {
      input.blur();
    }

    // Optionally, handle backspace
    if (input.value.length === 0 && index > 0) {
      const prevInput = document.querySelectorAll('.otp-input')[
        index - 1
      ] as HTMLInputElement;
      prevInput.focus();
    }
  }
}
